function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".merge_active_svg__cls-1{fill:#6cff00;opacity:.572}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "merge_active_svg__Group_21665",
  transform: "translate(-2.899 -2.899)"
}, /*#__PURE__*/React.createElement("g", {
  id: "merge_active_svg__Component_131_3",
  transform: "translate(2.899 2.899)"
}, /*#__PURE__*/React.createElement("path", {
  id: "merge_active_svg__Exclusion_2",
  d: "M7 0a7 7 0 11-7 7 7 7 0 017-7z",
  className: "merge_active_svg__cls-1"
}), /*#__PURE__*/React.createElement("circle", {
  id: "merge_active_svg__Ellipse_688",
  cx: 7,
  cy: 7,
  r: 7,
  className: "merge_active_svg__cls-1",
  transform: "translate(7.07)"
})));
function SvgMergeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "merge_active_svg__Component_134_1",
    width: 21.07,
    height: 14,
    viewBox: "0 0 21.07 14"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' id='Component_134_1' width='21.07' height='14' viewBox='0 0 21.07 14'%3e %3cdefs%3e %3cstyle%3e .cls-1%7bfill:%236cff00;opacity:.572%7d %3c/style%3e %3c/defs%3e %3cg id='Group_21665' transform='translate(-2.899 -2.899)'%3e %3cg id='Component_131_3' transform='translate(2.899 2.899)'%3e %3cpath id='Exclusion_2' d='M7 0a7 7 0 1 1-7 7 7 7 0 0 1 7-7z' class='cls-1'/%3e %3ccircle id='Ellipse_688' cx='7' cy='7' r='7' class='cls-1' transform='translate(7.07)'/%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgMergeActive as ReactComponent };